import { Panel } from "./Panel";

type WarningPanelProps = {
  title: string;
  warnings: string[];
};

export function WarningPanel({ title, warnings }: WarningPanelProps) {
  const uniqueWarnings = Array.from(new Set(warnings.filter(Boolean)));
  if (uniqueWarnings.length === 0) return null;

  return (
    <Panel className="warning-panel" aria-live="polite">
      <h2>{title}</h2>
      <ul>
        {uniqueWarnings.map((warning) => (
          <li key={`${title}-${warning}`}>{warning}</li>
        ))}
      </ul>
    </Panel>
  );
}
